export default {
  customerUrl: null,
  id: null, // only used: hasActiveSession = session => !!session.id && !session.isEnded;
  isAgentTyping: null,
  isEnded: null, // note: used indirectly to calculate hasActiveSession
  endedReason: null,
  unreadCount: 0,
  welcomeMessage: null,
};
